const BASE_URL = "/master-data/general-ledger";

export default [
  {
    path: `${BASE_URL}/coa`,
    name: "COA",
    component: () => import("@/pages/masterData/chartOfAccount/Index.vue"),
  },
  {
    path: `${BASE_URL}/coa-category`,
    name: "COACategoryList",
    component: () => import("@/pages/masterData/coaCategory/Index.vue"),
  },
  {
    path: `${BASE_URL}/budget`,
    name: "GeneralLedgerBudget",
    component: () => import("@/pages/masterData/generalLedgerBudget/Index.vue"),
  },
  {
    path: `${BASE_URL}/cash-flow-budget`,
    name: "CashFlowBudget",
    component: () => import("@/pages/masterData/cashFlowBudget/Index.vue"),
  },
];
